import React from 'react'
import styled from 'styled-components'
import theme from './theme.js'
import {useHeaderContext} from './header.js' 
import media from './theme-media.js'

const UnstyledMenuToggle = ({
  className
}) => {
  const header = useHeaderContext()
  const isOpen = header.mobileMenuIsOpen
  const onClick = () => header.setMobileMenuIsOpen(!isOpen)

  const props = {
    className,
    header,
    onClick
  }

  const barProps = {
    isOpen
  }

  return (
    <div {...props}>
      <BarTop {...barProps}/>
      <BarMid {...barProps}/>
      <BarLow {...barProps}/>
    </div>
  )
}

const MenuToggle = styled(UnstyledMenuToggle)`
  width: 3rem;
  height: ${theme.padding.extraSmall};
  cursor: pointer;
  z-index: 110;
  ${media.aboveTablet`
    display: none;
  `}
`

const thickness = '2px'

const BarTop = styled.div`
  position: absolute;
  background: ${theme.color.grey.darkest};
  width: 100%;
  height: ${thickness};
  top: 0;

  ${props => props.isOpen ? `
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%) rotate(-45deg);
  ` : null}
`

const BarLow = styled.div`
  position: absolute;
  background: ${theme.color.grey.darkest};
  width: 100%;
  height: ${thickness};
  bottom: 0;

  ${props => props.isOpen ? `
    bottom: initial;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%) rotate(45deg);
  ` : null}
`

const BarMid = styled.div`
  position: absolute;
  background: ${theme.color.grey.darkest};
  width: 100%;
  height: ${thickness};
  top: 50%;
  transform: translateY(-50%);
  display: ${props => props.isOpen ? 'none' : 'block'};
`

export default MenuToggle